import { subscriptionFieldsToCheck } from "./formHelper";

export const validateFieldsArray = async (thisErrors, thisValidator, fieldsArray) => {
  thisErrors.clear();
  thisErrors.add({});
  let hasErrors = 0;
  const promises = fieldsArray.map(async (field) => {
    const isOk = await thisValidator.validate(field);
    if (!isOk) {
      hasErrors +=1;
    }
  });

  await Promise.all(promises)
  return hasErrors === 0;
};

export const validateFormStep3 = async (
  thisErrors, thisValidator, form, participantAge, genderError, specialNeedError, maritalError
  ) => {
  thisErrors.clear();
  thisErrors.add({});
  let hasErrors = 0;
  const index = participantAge < 18 ? 3 : 2;
  const promises = subscriptionFieldsToCheck[index].map(async (field) => {
    const isOk = await thisValidator.validate(field);
    if (!isOk) {
      hasErrors +=1;
    }
  });

  if (!form.gender) {
    genderError = true;
    hasErrors +=1;
  }

  if (!form.specialNeeds) {
    specialNeedError = true;
    hasErrors +=1;
  }

  if (!form.maritalStatus) {
    maritalError = true;
    hasErrors +=1;
  }

  await Promise.all(promises)
  return hasErrors === 0;
};